import { createAuthContext } from '../../base/auth/context';

export const AdminAuthContext = createAuthContext({ member: { roles: [], assetTypes: [] }, loading: true, env: '' });
